import type { TPracticeStaffUserSettings } from "./types";
import { createPathParam, type NoPathParams } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "practice/practice-staff/set-user-settings";

export default createService(SLUG, {
  save: createPathParam<TPracticeStaffUserSettings, NoPathParams, TPracticeStaffUserSettings>(SLUG),
});
